import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import * as yup from 'yup';

const gtZero = (value) => {
  return value !== '' && value !== null && value !== undefined && value > 0;
};
const gt44 = (value) => {
  return value !== '' && value !== null && value !== undefined && value.length === 44;
};

const produtosServicosSchema = yup.array(
  yup.object().shape({
    produtoServico: yup
      .object()
      .nullable()
      .required(mensagemCampoObrigatorio('o produto/serviço')),
    quantidade: yup
      .number()
      .nullable()
      .required('A quantidade deve ser superior a zero')
      .test('quantidadeGtZero', 'A quantidade deve ser superior a zero', gtZero),
    valor: yup
      .string()
      .nullable()
      .required(mensagemCampoObrigatorio('o valor'))
      .test('valorGtZero', mensagemCampoObrigatorio('o valor'), gtZero),
  })
);

const schemaNotaDevolucao = yup.object().shape({
  operacao: yup
    .string()
    .nullable()
    .required(mensagemCampoObrigatorio('a operação')),
  chaveAcesso: yup
    .string()
    .nullable()
    .required(mensagemCampoObrigatorio('a chave de acesso da nota fiscal'))
    .test('quantidadeCaracteres', 'A chave de acesso deve ter 44 dígitos', gt44),
  cliente: yup
    .object()
    .nullable()
    .test('cliente', mensagemCampoObrigatorio('o cliente'), function(cliente) {
      if (this.parent.operacao === 'VENDA') {
        return !!cliente?.id;
      }
      return true;
    }),

  fornecedor: yup
    .object()
    .nullable()
    .test('fornecedor', mensagemCampoObrigatorio('o fornecedor'), function(fornecedor) {
      if (this.parent.operacao === 'COMPRA') {
        return !!fornecedor?.id;
      }
      return true;
    }),

  produtosServicos: produtosServicosSchema,
  valorDesconto: yup
    .number()
    .nullable()
    .test('valorDesconto', mensagemCampoObrigatorio('o desconto'), function(valorDesconto) {
      const tipoDesconto = this.parent.tipoDesconto !== ' ' ? this.parent.tipoDesconto : false;

      return tipoDesconto ? valorDesconto !== '' && valorDesconto !== null && valorDesconto !== undefined : true;
    })
    .test('valorDesconto', 'O valor deve ser superior a zero', function(valorDesconto) {
      const tipoDesconto = this.parent.tipoDesconto !== ' ' ? this.parent.tipoDesconto : false;

      return tipoDesconto ? gtZero(valorDesconto) : true;
    })
    .test('valorDesconto', 'O valor de desconto não pode ser maior que o somatório dos subtotais', function(
      valorDesconto
    ) {
      const tipoDesconto = this.parent.tipoDesconto !== ' ' ? this.parent.tipoDesconto : false;
      return tipoDesconto ? this.parent.valorTotal + valorDesconto > valorDesconto : true;
    }),
});

export default schemaNotaDevolucao;
